import Vue from 'vue';
import VueRouter from 'vue-router';

import adminRoutes from '@/router/routes/admin';
import accessRoutes from "@/router/routes/access";
import profileRoutes from "@/router/routes/profile";
import Home from '@/views/Home.vue';


Vue.use(VueRouter);

const baseRoutes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { authorize: [] },
  },
];

const routes = baseRoutes
  .concat(adminRoutes)
  .concat(accessRoutes)
  .concat(profileRoutes)
  .concat({ path: '*', redirect: '/' })

const router = new VueRouter({
  routes
});

const isAuthorized = (authorize) => {
  if (!authorize.length) {
    return true;
  } else if (Vue.prototype.$auth.getUserRoles().filter(value => authorize.includes(value)).length) {
    return true;
  }
  return false;
}

router.beforeEach((to, _, next) => {
  var { authorize } = to.meta
  if (!Vue.prototype.$auth.isAuthenticated) {
    Vue.prototype.$auth.signIn().then(() => {
      if (isAuthorized(authorize)) {
        return next();
      }
      return next("Home")
    })
  } else {
    if (isAuthorized(authorize)) {
      return next();
    }
    return next("Home")
  }
});

export default router;
